import { initSideMenu } from "./components/side-menu";
// import * as bla from "./components/macy.min.js" Impossible to load... CDN instead

initSideMenu()

var macyInstance = Macy({
  // See below for all available options.
  container: ".list",
  mobileFirst: true,
  columns: 1,
  breakAt: {
    1200: 4,
    940: 3,
    520: 2
  }
});


window.addEventListener("click", e => {
  if (e.target.closest(".thumbnail")) {
    console.log(e.target.src)

    const imgModal = document.getElementById("modalImg")

    /* Filling right info from target */
    imgModal.querySelector("img").src = e.target.src
    imgModal.querySelector(".caption").innerText = e.target.alt

    imgModal.classList.add("active")

    imgModal.querySelector(".closeModal").addEventListener("click", e => {
      imgModal.classList.remove("active")
    })

    imgModal.addEventListener("click", e => {
      // if (!e.target.closest(".content")) {
        imgModal.classList.remove("active")
      // }
    })

  }
})